module.exports = __webpack_public_path__ + "img/net_des_2.5228bffe.jpg";